import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Toast, ToastQueueService } from '../../../services/toast-queue.service';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.css'
})
export class ToastContainerComponent implements OnInit, OnDestroy {
  toasts: Toast[] = [];
  private sub = new Subscription();

  constructor(private toastQueue: ToastQueueService) {}

  ngOnInit(): void {
    this.sub.add(
      this.toastQueue.toasts$.subscribe(t => { this.toasts = t; })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  dismiss(id: string): void {
    this.toastQueue.dismiss(id);
  }

  dismissAll(): void {
    this.toastQueue.dismissAll();
  }

  formatType(type: string): string {
    const t = (type ?? '').toLowerCase().replace(/\s+/g, '');
    if (t === 'cloudsettings') return 'Cloud Settings';
    if (t.includes('lrc'))     return 'LRC Filling';
    if (t.includes('quota'))   return 'Policy';
    return type || 'Notification';
  }

  formatTime(ts: Date): string {
    try {
      return new Date(ts).toLocaleTimeString('en-GB', {
        hour: 'numeric', minute: '2-digit', hour12: false
      });
    } catch {
      return '';
    }
  }
}
